/** CPF: UI mask 999.999.999-99; Auth0/Sensedia receive digits only. */

export function digitsOnly(value: string): string {
  return value.replace(/\D/g, '').slice(0, 11)
}

export function formatCpf(value: string): string {
  const d = digitsOnly(value)
  if (d.length <= 3) return d
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`
}

export function isValidCpfLength(value: string): boolean {
  return digitsOnly(value).length === 11
}

/** Valida dígitos verificadores do CPF (ignora pontuação). */
export function isValidCpf(value: string): boolean {
  const cpf = digitsOnly(value)
  if (cpf.length !== 11) return false
  if (/^(\d)\1{10}$/.test(cpf)) return false

  const calc = (base: string, factor: number) => {
    let sum = 0
    for (let i = 0; i < base.length; i++) {
      sum += Number(base[i]) * (factor - i)
    }
    const mod = (sum * 10) % 11
    return mod === 10 ? 0 : mod
  }

  const d1 = calc(cpf.slice(0, 9), 10)
  const d2 = calc(cpf.slice(0, 10), 11)
  return d1 === Number(cpf[9]) && d2 === Number(cpf[10])
}

/** Garante payload Auth0/Sensedia: exatamente 11 dígitos ou lança. */
export function toAuth0Username(cpfInput: string): string {
  const cpf = digitsOnly(cpfInput)
  if (!isValidCpf(cpf)) {
    throw new Error('CPF_INVALID')
  }
  return cpf
}
